import { abstract } from './config/abstract';
import { apeChain } from './config/apeChain';
import { arbitrum } from './config/arbitrum';
import { astarZkEVM } from './config/astarZkEVM';
import { aurora } from './config/aurora';
import { avalanche } from './config/avalanche';
import { base } from './config/base';
import { berachain } from './config/berachain';
import { blast } from './config/blast';
import { bob } from './config/bob';
import { bsc } from './config/bsc';
import { celo } from './config/celo';
import { cronoszkEVM } from './config/cronoszkEVM';
import { cyber } from './config/cyber';
import { degen } from './config/degen';
import { ethereum } from './config/ethereum';
import { ethereumSepolia } from './config/ethereumSepolia';
import { fantom } from './config/fantom';
import { fogo } from './config/fogo';
import { fogoTestnet } from './config/fogoTestnet';
import { fraxtal } from './config/fraxtal';
import { gnosis } from './config/gnosis';
import { gravity } from './config/gravity';
import { hyperEVM } from './config/hyperEVM';
import { ink } from './config/ink';
import { lens } from './config/lens';
import { linea } from './config/linea';
import { lisk } from './config/lisk';
import { manta } from './config/manta';
import { mantle } from './config/mantle';
import { megaeth } from './config/megaeth';
import { megaethTestnet } from './config/megaethTestnet';
import { metis } from './config/metis';
import { mode } from './config/mode';
import { monad } from './config/monad';
import { near } from './config/near';
import { nearIntents } from './config/nearIntents';
import { okbchain } from './config/okbchain';
import { opBNB } from './config/opBNB';
import { optimism } from './config/optimism';
import { polygon } from './config/polygon';
import { polygonZkEvm } from './config/polygonZkEvm';
import { polynomial } from './config/polynomial';
import { rari } from './config/rari';
import { real } from './config/real';
import { redstone } from './config/redstone';
import { robinhood } from './config/robinhood';
import { ronin } from './config/ronin';
import { scroll } from './config/scroll';
import { sei } from './config/sei';
import { solana } from './config/solana';
import { soneium } from './config/soneium';
import { sonic } from './config/sonic';
import { sui } from './config/sui';
import { swellchain } from './config/swellchain';
import { taiko } from './config/taiko';
import { unichain } from './config/unichain';
import { viction } from './config/viction';
import { worldchain } from './config/worldchain';
import { zeroNetwork } from './config/zeroNetwork';
import { zkLinkNova } from './config/zkLinkNova';
import { zksync } from './config/zksync';
import { zora } from './config/zora';
import type { AllChainConfig, ChainRuntime } from './configTypes';

// Just so we can define ChainKey in terms of this set
const _chains = {
  abstract,
  apeChain,
  arbitrum,
  astarZkEVM,
  aurora,
  avalanche,
  base,
  berachain,
  blast,
  bob,
  bsc,
  celo,
  cronoszkEVM,
  cyber,
  degen,
  ethereum,
  ethereumSepolia,
  fantom,
  fogo,
  fogoTestnet,
  fraxtal,
  gnosis,
  gravity,
  hyperEVM,
  ink,
  lens,
  linea,
  lisk,
  manta,
  mantle,
  megaeth,
  megaethTestnet,
  metis,
  mode,
  monad,
  near,
  nearIntents,
  okbchain,
  opBNB,
  optimism,
  polygon,
  polygonZkEvm,
  polynomial,
  rari,
  real,
  redstone,
  robinhood,
  ronin,
  scroll,
  sei,
  solana,
  soneium,
  sonic,
  sui,
  swellchain,
  taiko,
  unichain,
  viction,
  worldchain,
  zeroNetwork,
  zkLinkNova,
  zksync,
  zora,
} as const;

// Only the "all" exports are created here
// derivations are created in ../derivedTypes.ts, ../derivedConstants.ts, and ../functions.ts
export type AllChainKey = keyof typeof _chains;

export type AllChains = Record<
  AllChainKey,
  AllChainConfig<ChainRuntime, boolean>
>;
export const allChains = { ..._chains } satisfies AllChains;
